/*
 * @Author: lidan
 * @Date: 2020-11-12 10:21:27
 * @LastEditTime: 2021-03-31 19:41:05
 * @LastEditors: lidan
 * @Description: 下拉框api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\select.js
 */

import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_FINANCIAL_WEB
} = e6ModuleSettleAccountsCenterApi;

// (下拉框)查询全部的承运商信息
export function findAllCarrierByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "post",
    data
  });
}

// (下拉框)查询全部的客户信息
export function findAllCustomerByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCustomerByPage`,
    method: "post",
    data
  });
}

// (下拉框)查询全部的合同信息
export function findAllContractByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/getInfoDropBox`,
    method: "post",
    data
  });
}

// 获取区域下拉
export function getAreaLablePosition(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}

//电子路书（下拉框）
export function findFixedBillWay(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/getFixedLineInfoDropBox`,
    method: "post",
    data
  });
}

//获取车型下拉数据
export function findPageCarModelData(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findPage`,
    method: "post",
    data
  });
}

//获取车辆下拉树数据源
export function getVehicleTreeList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getOrgVehicleTree`,
    method: "get"
  });
}

//获取司机下拉数据
export function findAllDriverByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/findAllDriverByPage`,
    method: "post",
    data
  });
}

//获取费目下拉数据源
export function getFeeItemList(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/feeItem/getDropBox`,
    method: "post",
    data
  });
}

//获取费目下拉数据源 - all
export function getAllFeeItemList(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/feeItem/getAllFeeItemDropBox`,
    method: "post",
    data
  });
}

// 获取司机津贴下拉数据源
export function getAllowanceDropBox(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/allowance/getAllowanceDropBox`,
    method: "post",
    data
  });
}

//(下拉框)查询所属部门信息
export function findOrganizationTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}

// 合同类型下拉
export function getContractType() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/getTypeDropBox`,
    method: "post"
  });
}

// 合同统计方式
export function getContractStatisticType() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/getStatisticTypeDropBox`,
    method: "post"
  });
}

// 合同统计方式
export function getContractStatusDropBox() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractInfo/getStatusDropBox`,
    method: "post"
  });
}

//更改记录 用户下拉树
export function fetchUserTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getUserTree`,
    method: "get"
  });
}

// 获取省市区树下拉
export function getCityAreaCode() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/diAreaCode/listArea`,
    method: "get"
  });
}

//送货员下拉
export function findAllDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/findAllDelivery`,
    method: "post",
    data
  });
}

// 送货员津贴下拉
export function getDeliveryDropBox(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/getDeliveryDropBox`,
    method: "post",
    data
  });
}
